import { OMath } from "@olga-food/schemas/lib/classes/tools/OMath";

export class NetLogicItem {
  item = null;

  constructor(item) {
    this.item = item;
  }

  mountCondiment(condiment) {
    const sku = getSku(condiment);
    return {
      index: 0,
      id: sku,
      name: condiment.name,
      externalCode: sku,
      quantity: condiment.quantity || 1,
      price: condiment.price,
      totalPrice: +OMath.times(condiment.quantity || 1, condiment.price || 0),
      discount: 0,
      discountCode: 0,
      discountInfo: "",
      addition: 0,
      subItems: [],
      subItemsPrice: 0,
      observations: condiment.observation || "",
    };
  }

  mountSubItem(sub_item, options = []) {
    const sku = getSku(sub_item);
    const price =
      sub_item.sizes && sub_item.sizes[0]
        ? sub_item.sizes[0].price
        : sub_item.price || 0;

    const condiments = [];
    while (options.length > 0) {
      const option = options.splice(0, 1)[0];
      if (isCondiment(option)) {
        condiments.push(this.mountCondiment(option, options));
      } else {
        options.unshift(option);
        break;
      }
    }

    return {
      index: 0,
      id: sku,
      externalId: sku,
      externalCode: sku,
      name: sub_item.name,
      quantity: sub_item.quantity || 1,
      price: price,
      totalPrice: +OMath.times(sub_item.quantity || 1, price),
      discount: 0,
      discountCode: 0,
      discountInfo: "",
      addition: 0,
      subItemsPrice: 0,
      subItems: condiments,
      observations: sub_item.observation || "",
    };
  }

  mountItem(item, options = []) {
    const sku = getSku(item);

    const price =
      item.sizes && item.sizes[0] ? item.sizes[0].price : item.price || 0;

    const sub_items = [];
    while (options.length > 0) {
      const option = options.splice(0, 1)[0];
      if (isSubItem(option)) {
        sub_items.push(this.mountSubItem(option, options));
      } else if (isCondiment(option)) {
        sub_items.push(this.mountCondiment(option, options));
      } else {
        options.unshift(option);
        break;
      }
    }

    return {
      index: 0,
      id: sku,
      externalId: sku,
      externalCode: sku,
      name: item.name,
      quantity: this.item.quantity || item.quantity || 1,
      price: price,
      totalPrice: +OMath.times(item.quantity || 1, price),
      discount: 0,
      discountCode: 0,
      discountInfo: "",
      addition: 0,
      subItemsPrice: 0,
      subItems: sub_items,
      observations: item.observation || "",
    };
  }

  /**
   *
   * @returns {Array<Object>}
   */
  export() {
    const options = [];
    for (const question of this.item.items) {
      for (const option of question.items) {
        if (option.selected) {
          options.push(option);
        }
      }
    }

    if (isItem(this.item)) {
      if (options.length == 0) {
        return [this.mountItem(this.item, [])];
      }
      options.unshift(this.item);
    }

    const items = [];
    while (options.length > 0) {
      const option = options.splice(0, 1)[0];
      if (!isItem(option)) {
        continue;
      }
      items.push(this.mountItem(option, options));
    }

    const final = [];
    for (let i = 0; i < this.item.quantity; i++) {
      final.push(
        ...items.map((i) => {
          i.quantity = 1;
          return i;
        })
      );
    }

    return final;
  }
}

const getSku = (item) => {
  if (item.sizes && item.sizes.length > 0) {
    const size = item.sizes[0];
    if (size && size.sku) {
      return size.sku;
    }
  }
  return item.sku || ``;
};

const isItem = (item) => {
  return getSku(item).startsWith("I");
};

const isSubItem = (item) => {
  return getSku(item).startsWith("S");
};

const isCondiment = (item) => {
  return getSku(item).startsWith("C");
};
